import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { restoreCategory } from "../../api/apiCategories";
import parseError from "../../utils/parseError";

const useRestoreCategory = () => {
    const queryClient = useQueryClient();

    const {
        mutate: restoreCat,
        isPending: isRestore,
    } = useMutation({
        mutationFn: restoreCategory,
        onSuccess: (response) => {
            toast.success(response.message);
            queryClient.invalidateQueries({ queryKey: ["categories"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to restore category");
        },
    });

    return {
        restoreCat,
        isRestore,
    };
};

export default useRestoreCategory;
